import React from 'react';
import { Link } from 'react-router-dom';

function HomePage() {
  return (
    <div className="relative max-w-4xl mx-auto px-4">
      {/* Decorative glossy orbs behind hero */}
      <div
        className="pointer-events-none absolute -left-8 top-1/4 h-32 w-32 rounded-full border border-white/40 bg-gradient-to-br from-white/35 to-sky-400/20 shadow-aero-bubble blur-[1px] animate-aero-float hidden sm:block"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -right-4 top-8 h-24 w-24 rounded-full border border-cyan-200/50 bg-gradient-to-br from-white/40 to-cyan-300/25 shadow-lg animate-aero-float [animation-delay:-4s] hidden sm:block"
        aria-hidden
      />

      <div className="glass-card rounded-[2rem] p-6 sm:p-12 transform hover:scale-[1.008] transition-all duration-500 aero-glow ring-1 ring-slate-300/40">
        <div className="relative z-10">
          <h1 className="font-display text-4xl sm:text-6xl font-semibold mb-6 sm:mb-8 aero-title-gradient-dark tracking-tight">
            Daniel Kuzmin
          </h1>
          <p className="text-lg sm:text-2xl text-slate-800/95 font-light leading-relaxed mb-8 sm:mb-12 max-w-2xl mx-auto [text-shadow:0_1px_0_rgba(255,255,255,0.35)]">
            Software engineer in the Bay Area, currently at AWS.
            Building distributed systems to store, process, and vend data across the AWS network.
            Experienced in Java, Python, Kotlin, TypeScript, and cloud infrastructure.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6">
            <Link
              to="/resume"
              className="glass-button px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg rounded-full inline-flex items-center justify-center gap-2 shadow-lg hover:shadow-xl transition-all duration-300 font-display font-medium"
            >
              <span>View Resume</span>
              <svg className="w-5 h-5 shrink-0 opacity-95" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </Link>
            <Link
              to="/blog"
              className="glass-button px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg rounded-full inline-flex items-center justify-center gap-2 shadow-lg hover:shadow-xl transition-all duration-300 font-display font-medium"
            >
              <span>View Blog</span>
              <svg className="w-5 h-5 shrink-0 opacity-95" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
